import { Drawer, createDrawer } from '@nexelem/drawer';
import { Button } from '@nexelem/components';
import { FilterData } from '@nexelem/filters';
import { useStore } from 'zustand';
import { useCustomTranslation } from '../../../hooks';
import { openCreateOrEditFilterModal } from '../../molecules/filters/CreateOrEditFilterModal';
import { SavedFilters } from '../../molecules/SavedFilters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/pro-light-svg-icons';
import { GridFiltersProps } from '@nexelem/table';

type FiltersManagerDrawerProps = Pick<GridFiltersProps, 'store' | 'filters' | 'onChange'>;

const FiltersManagerDrawer = ({ store, filters, onChange }: FiltersManagerDrawerProps) => {
  const setActiveId = useStore(store, (state) => state.setActiveId);
  const { tWrapper } = useCustomTranslation('components.drawers.filterManager');

  const onClickResetFilters = () => {
    onChange({} as FilterData);
    setActiveId();
  };

  const onApplyFilters = (newFilters: FilterData) => {
    onChange(newFilters);
  };

  return (
    <Drawer>
      <Drawer.Header
        className="border-0"
        title={<div className="text-t24-sb">{tWrapper('header')}</div>}
        onClose={closeFiltersManagerDrawer}
      />
      <Drawer.Content className="p-0 pr-3">
        <SavedFilters filters={filters} store={store} onApplyFilters={onApplyFilters} />
      </Drawer.Content>
      <Drawer.Footer>
        <Button variant="text" onClick={onClickResetFilters}>
          {tWrapper('reset')}
        </Button>
        <Button
          StartIcon={<FontAwesomeIcon icon={faBookmark} />}
          variant="text"
          onClick={() => openCreateOrEditFilterModal({ filters, store })}
        >
          {tWrapper('save')}
        </Button>
      </Drawer.Footer>
    </Drawer>
  );
};

export const { toggleFiltersManagerDrawer, closeFiltersManagerDrawer } = createDrawer(FiltersManagerDrawer, {
  name: 'FiltersManagerDrawer',
  width: 420,
  slot: 'right',
  drawerId: () => 'filters-manager-drawer',
});
